module.exports = __webpack_public_path__ + "img/_Large-Vertical-Rectangular-Attachment.224eadb3.jpg";